import { useState, useCallback } from 'react';
import { conceptExplanations } from '../data/conceptExplanations';
import { SEARCH_CONFIG } from '../data/constants';

// useSearch Hook - Extracted from App.js for better maintainability
// Handles search functionality with relevance scoring

const useSearch = (getDomainFromKey) => {
  const [searchTerm, setSearchTerm] = useState('');

  // Search functionality (memoized for performance)
  const searchConcepts = useCallback((term) => {
    if (!term || term.length < SEARCH_CONFIG.MIN_SEARCH_LENGTH) return [];
    const searchTerm = term.toLowerCase().trim();
    const results = [];
    
    Object.entries(conceptExplanations).forEach(([key, concept]) => {
      if (!concept) return; // Skip if concept is undefined
      
      let relevanceScore = 0;
      const title = (concept.title || '').toLowerCase();
      const explanation = (concept.explanation || '').toLowerCase();
      const examples = (concept.examples || '').toLowerCase();
      const mnemonic = concept.mnemonic ? concept.mnemonic.toLowerCase() : '';
      
      // Higher score for title matches
      if (title.includes(searchTerm)) relevanceScore += SEARCH_CONFIG.RELEVANCE_SCORES.TITLE_MATCH;
      if (title.startsWith(searchTerm)) relevanceScore += SEARCH_CONFIG.RELEVANCE_SCORES.TITLE_START;
      
      // Medium score for explanation matches
      if (explanation.includes(searchTerm)) relevanceScore += SEARCH_CONFIG.RELEVANCE_SCORES.EXPLANATION_MATCH;
      
      // Lower score for examples and mnemonic matches
      if (examples.includes(searchTerm)) relevanceScore += SEARCH_CONFIG.RELEVANCE_SCORES.EXAMPLES_MATCH;
      if (mnemonic.includes(searchTerm)) relevanceScore += SEARCH_CONFIG.RELEVANCE_SCORES.MNEMONIC_MATCH;
      
      // Exact word matches get bonus points
      const words = searchTerm.split(' ');
      words.forEach(word => {
        if (word.length > SEARCH_CONFIG.MIN_WORD_LENGTH) {
          if (title.includes(` ${word} `) || title.startsWith(`${word} `) || title.endsWith(` ${word}`)) {
            relevanceScore += SEARCH_CONFIG.RELEVANCE_SCORES.WORD_MATCH_TITLE;
          }
          if (explanation.includes(` ${word} `)) {
            relevanceScore += SEARCH_CONFIG.RELEVANCE_SCORES.WORD_MATCH_EXPLANATION;
          }
        }
      });
      
      if (relevanceScore > 0) {
        results.push({ 
          key, 
          ...concept, 
          relevanceScore,
          // Add domain information for better context
          domain: getDomainFromKey(key)
        });
      }
    });
    
    // Sort by relevance score (highest first)
    return results.sort((a, b) => b.relevanceScore - a.relevanceScore);
  }, [getDomainFromKey]);

  return {
    searchTerm,
    setSearchTerm,
    searchConcepts
  };
};

export default useSearch;